import * as React from "react";
import * as ReactDOM from "react-dom";
import { Loader } from "@progress/kendo-react-indicators";

export const LoadingScreen = () => {
    return <div className="k-loading-mask">
        <div className="h-100 d-flex align-items-center justify-content-center">
            <Loader type="converging-spinner" size="large" />
        </div>
        <div className="k-loading-color"></div>
    </div>;
}